import { PayloadAction } from '@reduxjs/toolkit';
import {
  fetchModuleAvailableList,
  createModule,
  updateModule,
  fetchModuleDetail,
  fetchSubModuleTree,
  createSubModule,
  deleteSubModule,
  fetchSubModuleDetail,
  fetchEdxQuestionByModule,
  updateSubModule,
  deleteSubModlueQuestion,
  fetchEdxListCourse,
  syncEdxCourse,
  syncEdxCourseDirect,
  cloneModuleFromEdxCourse,
  fetchActiveSubModuleClassPractice,
  createActiveSubModuleClassPractice,
  addGradeModule,
  fetchSubModuleV2,
  createActiveSubModuleClassPracticeV2,
  createActiveSubmoduleClassExam,
  createExamExtend,
  deleteModule,
} from '@store/actions/moduleAction';
import {
  setModuleAvailableList,
  setLoading,
  setModuleDetail,
  setSubModuleTree,
  setLoadingSubModuleTree,
  setSubModuleDetail,
  setLoadingSubModuleDetail,
  setEdxQuestionByModule,
  setEdxListCourse,
  setSyncSuccess,
  setLoadingEdxListCourse,
  setLoadingActiveSubModuleClassPractice,
  setSuccessActiveSubModuleClassPractice,
  setResultsActiveSubModuleClassPractice,
  setActiveSubModuleClassPractice,
  setLoadingModuleDetail,
  setGradeModuleList,
  setLoadingAddModuleGrade,
  setSubModuleV2,
  setLoadingDeleteModule,
  setDeleteModuleSuccess,
  resetModuleData,
} from '@store/reducers/moduleReducer';
import { resourceService } from '@libs/axios';
import { toast } from 'react-toastify';
import { Action } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { history } from '@utils/BrowserHistory';
import { ResponseType } from '@store/index';
const API_URL = process.env.REACT_APP_API_URL;

function* fetchModuleAvailableListSaga(): Generator<any, void, any> {
  try {
    yield put(setLoading(true));
    const response: any = yield call(resourceService.get, API_URL + '/api/list_course_avail/');
    if (response.status === 200) {
      yield put(setModuleAvailableList(response.data?.data));
      yield put(setLoading(false));
    }
  } catch (error: any) {
    yield put(setLoading(false));
    console.error(error);
  }
}

function* createModuleSaga(action: ReturnType<any>): Generator<any, void, any> {
  yield put(setLoading(true));
  const { data } = action.payload;
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + '/api/modules/', data);
    if (response.status === 201) {
      const { id } = response?.data;
      history.push(`/admin/module/?id=${id}&mode=view`)
      toast.success('Tạo môn học thành công');
      yield put(setLoading(false));
    }
  } catch (error: any) {
    console.log(error);
    yield put(setLoading(false));
  }
}

function* fetchModuleDetailSaga(action: ReturnType<any>): Generator<any, void, any> {
  const { id } = action.payload;
  yield put(setLoadingAddModuleGrade(0));
  yield put(setLoading(true));
  yield put(setLoadingModuleDetail(true));
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/modules/${id}`);
    if (response.status === 200) {
      yield put(
        setModuleDetail({
          id: response.data?.id ?? id,
          name: response.data?.name,
          grade: response.data?.grade,
          description: response.data?.description,
          type: response.data?.type,
          syllabus: response.data?.syllabus,
          edx_course_id: response.data?.edx_course_id,
          exam_duration: response.data?.exam_duration,
          exam_pass_score: response.data?.exam_pass_score,
          max_exams_students: response.data?.max_exams_students,
          status: response.data?.status,
          module_class_type: response.data?.module_class_type
        }),
      );
      yield put(setLoading(false));
      yield put(setLoadingModuleDetail(false));
    }
  } catch (error: any) {
    yield put(setLoading(false));
    yield put(setLoadingModuleDetail(false));
    console.error(error);
  }
}

function* fetchSubModuleTreeSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield put(setLoading(true));
    yield put(setLoadingSubModuleTree(true));
    const { moduleId, practice_type, tree_type } = action.payload;

    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/sub_modules/`, { params: { module_id: moduleId, practice_type, tree_type } }
    );
    if (response.status === 200) {
      yield put(setSubModuleTree(response.data));
    }
    yield put(setLoading(false));
    yield put(setLoadingSubModuleTree(false));
  } catch (error: any) {
    yield put(setLoading(false));
    yield put(setLoadingSubModuleTree(false));
    console.error(error);
  }
}
function* fetchSubModuleV2Saga(action: ReturnType<typeof fetchSubModuleV2>): Generator<any, void, any> {
  try {
    yield put(setLoading(true));
    const { moduleId, class_id, practice_type, active_class_submodules, type } = action.payload;
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + `/api/sub_modules_v2/`, { params: { module_id: moduleId, class_id, practice_type, active_class_submodules, type } }
    );
    if (response.status === 200) {
      yield put(setSubModuleV2(response.data));
      yield put(setLoading(false));
    }
  } catch (error: any) {
    yield put(setLoading(false));
    console.error(error);
  }
}
function* createSubModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield put(setLoading(true))
    const { data } = action.payload;
    const response: ResponseType = yield call(
      resourceService.post,
      API_URL + '/api/sub_modules/',
      data,
    );
    if (response.status === 201) {
      const getSubModuleTree: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/sub_modules/?module_id=${data.module}`,
      );
      if (getSubModuleTree.status === 200) {
        yield put(setSubModuleTree(getSubModuleTree.data));
        yield put(setLoading(false))
      }
    }
  } catch (error: any) {
    console.error(error);
    toast.error("Có lỗi xảy ra")
    yield put(setLoading(false))
  }
}

function* deleteSubModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield put(setLoading(true))
    const { subModuleId, moduleId } = action.payload;
    const response: ResponseType = yield call(resourceService.delete, API_URL + `/api/sub_modules/${subModuleId}/`)
    if (response.status === 204) {
      const getSubModuleTree: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/sub_modules/?module_id=${moduleId}`,
      );
      if (getSubModuleTree.status === 200) {
        yield put(setSubModuleTree(getSubModuleTree.data));
        yield put(setLoading(false))
      }
    }
  }
  catch (error: any) {
    console.error(error)
    yield put(setLoading(false))
  }
}

function* fetchSubModuleDetailSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const { subModuleId } = action.payload;
    yield put(setLoadingSubModuleDetail(true))
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/sub_modules/${subModuleId}/`)
    if (response.status === 200) {
      yield put(setSubModuleDetail(response.data))
      yield put(setLoadingSubModuleDetail(false))
    }
  }
  catch (error: any) {
    toast.error('Có lỗi xảy ra')
    yield put(setLoadingSubModuleDetail(false))
  }
}

function* fetchEdxQuestionByModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield put(setLoading(true))
    const { blockId } = action.payload;
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/get_course_tree/${blockId}`);
    if (response.status === 200) {
      yield put(setEdxQuestionByModule(response.data))
      yield put(setLoading(false))
    }
  }
  catch (error: any) {
    yield put(setLoading(false))
    console.error(error)
  }
}

function* updateSubModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const { subModuleId, moduleId, data } = action.payload;
    yield put(setLoading(true));
    const response: ResponseType = yield call(resourceService.put, API_URL + `/api/sub_modules/${subModuleId}/`, data);
    if (response.status === 200) {
      const getSubModuleTree: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/sub_modules/?module_id=${moduleId}`,
      );
      if (getSubModuleTree.status === 200) {
        yield put(setSubModuleTree(getSubModuleTree.data));
        yield put(setLoading(false))
      }
    }
  }
  catch (error: any) {
    console.error(error);
    yield put(setLoading(false))
  }
}

function* updateModuleSaga(action: ReturnType<typeof updateModule>): Generator<any, void, any> {
  yield put(setLoading(true));
  const { moduleId, data } = action.payload;
  try {
    const response: ResponseType = yield call(resourceService.put, API_URL + `/api/modules/${moduleId}/`, data);
    if (response.status === 200) {
      toast.success('Cập nhập môn học thành công');
      yield put(setLoading(false));
    }
  } catch (error: any) {
    console.log(error);
    yield put(setLoading(false));
  }
}

function* deleteSubModlueQuestionSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield put(setLoading(true))
    const { questionId, moduleId } = action.payload;
    const response: ResponseType = yield call(resourceService.delete, API_URL + `/api/submodulesquestions/${questionId}/`)
    if (response.status === 204) {
      const getSubModuleTree: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/sub_modules/?module_id=${moduleId}`,
      );
      if (getSubModuleTree.status === 200) {
        yield put(setSubModuleTree(getSubModuleTree.data));
        yield put(setLoading(false))
      }
    }
  }
  catch (error: any) {
    console.error(error)
    yield put(setLoading(false))
  }
}

function* fetchEdxListCourseSaga(action: Action): Generator<any, void, any> {
  try {
    yield put(setLoadingEdxListCourse(true));
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/edx_list_course/');
    if (response.status === 200) {
      yield put(setEdxListCourse(response.data?.data?.results));
      yield put(setLoadingEdxListCourse(false));
    }
  } catch (error: any) {
    console.error("Get list EDX course error", error);
    const detailError = error?.response?.data?.detail?.developer_message || 'Đã xảy ra lỗi không xác định';

    const match = detailError.match(/Request was throttled.*?(\d+)\s*seconds?/i);

    if (match) {
      const seconds = parseInt(match[1], 10);

      const viMessage = `Yêu cầu bị giới hạn bởi phía trang học liệu. Vui lòng thử lại sau ${seconds} giây.`;

      toast.error(viMessage);
      yield put(setLoadingEdxListCourse(false));
    } else {
      toast.error('Đồng bộ khóa học thất bại: ' + detailError);
      yield put(setLoadingEdxListCourse(false));
    }
  }
}

function* syncEdxCourseSaga(action: ReturnType<any>): Generator<any, void, any> {
  const { id } = action.payload;
  yield put(setSyncSuccess(false));
  yield put(setLoading(true));
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/edx_sync_course/${id}`);
    if (response.status === 200 || response.status === 202) {
      yield put(setSyncSuccess(true));
      yield put(setLoading(false));
      toast.success('Đã thêm môn học vào hàng đợi đồng bộ, hãy kiểm tra lại sau (Job ID: ' + response.data?.job_id + ')');
      // Refetch course available list and edx list course to update create_date
      yield call(function* () {
        yield put(setLoadingEdxListCourse(true));
        const listResponse: ResponseType = yield call(resourceService.get, API_URL + '/api/list_course_avail/');
        if (listResponse.status === 200) {
          yield put(setModuleAvailableList(listResponse.data?.data));
        }
        yield put(setLoadingEdxListCourse(false));
      });
    } else {
      yield put(setSyncSuccess(true));
      yield put(setLoading(false));
      toast.error('Đồng bộ môn học thất bại');
      console.error(response);
    }
  } catch (error: any) {
    yield put(setSyncSuccess(false));
    yield put(setLoading(false));
    toast.error('Đồng bộ môn học thất bại');
    console.error(error);
  }
}

function* syncEdxCourseDirectSaga(action: ReturnType<any>): Generator<any, void, any> {
  const { courseId } = action.payload;
  yield put(setSyncSuccess(false));
  yield put(setLoading(true));
  try {
    const response: ResponseType = yield call(
      resourceService.post,
      API_URL + '/api/edx_sync_course_direct/',
      { course_id: courseId }
    );
    if (response.status === 200 || response.status === 201) {
      yield put(setSyncSuccess(true));
      yield put(setLoading(false));
      toast.success('Đồng bộ khóa học thành công');
      // Refetch course available list and edx list course to update create_date
      yield call(function* () {
        yield put(setLoadingEdxListCourse(true));
        const listResponse: ResponseType = yield call(resourceService.get, API_URL + '/api/list_course_avail/');
        if (listResponse.status === 200) {
          yield put(setModuleAvailableList(listResponse.data?.data));
        }
        yield put(setLoadingEdxListCourse(false));
      });
    } else {
      yield put(setSyncSuccess(true));
      yield put(setLoading(false));
      toast.error('Đồng bộ khóa học thất bại');
      console.error(response);
    }
  } catch (error: any) {
    yield put(setSyncSuccess(false));
    yield put(setLoading(false));
    toast.error('Đồng bộ khóa học thất bại');
    console.error(error);
  }
}

function* cloneModuleFromEdxCourseSaga(action: ReturnType<any>): Generator<any, void, any> {
  try {
    yield put(setLoading(true));
    const { data } = action.payload;
    const payload = {
      ...data,
      max_exams_students: data?.max_exams_students ?? 3,
    };
    const response: ResponseType = yield call(
      resourceService.post,
      API_URL + '/api/clone_module_by_edx_source',
      payload,
    );
    if (response?.status === 201 && response.data) {
      const { id, edx_course_id } = response?.data?.module;
      history.push(`/admin/module/?id=${id}&mode=view`)
      toast.success('Tạo môn học thành công');
    }
    yield put(setLoading(false));
  }
  catch (error: any) {
    console.error(error);
  }
}

function* fetchActiveSubModuleClassPracticeSaga(action: ReturnType<any>): Generator<any, void, any> {
  const { class_ids, module } = action.payload;
  yield put(setLoadingActiveSubModuleClassPractice(true));
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/active_submodule_class_practice/?class_ids=${class_ids}&module=${module}`);
    if (response?.status === 200) {
      yield put(setActiveSubModuleClassPractice(response.data));
      yield put(setLoadingActiveSubModuleClassPractice(false));
    }
  }
  catch (error: any) {
    console.error(error);
    yield put(setLoadingActiveSubModuleClassPractice(false));
  }
}

function* createActiveSubModuleClassPracticeSaga(action: ReturnType<any>): Generator<any, void, any> {
  const { sub_module_id, class_id, submodule_name, module_id } = action.payload;
  yield put(setLoadingActiveSubModuleClassPractice(true));
  try {
    const response: ResponseType = yield call(resourceService.post, API_URL + `/api/active_submodule_class_practice/`, { sub_module_id, class_id });
    if (response?.status === 201 || response?.status === 200) {
      yield put(setLoadingActiveSubModuleClassPractice(false));
      if (response?.data?.id) {
        toast.success(`Giao học liệu thành công`);
        const responseRefresh: ResponseType = yield call(resourceService.get, API_URL + `/api/active_submodule_class_practice/?class_ids=${class_id}&module=${module_id}`);
        if (responseRefresh?.status === 200) {
          yield put(setActiveSubModuleClassPractice(responseRefresh.data));
          yield put(setLoadingActiveSubModuleClassPractice(false));
        } else {
          yield put(setLoadingActiveSubModuleClassPractice(false));
        }
      } else {
        toast.warning(`Học liệu ${submodule_name} đã được giao trước đó`);
      }
    }
  }
  catch (error: any) {
    console.error(error);
    toast.error(`Giao học liệu ${submodule_name} thất bại`);
    yield put(setLoadingActiveSubModuleClassPractice(false));
  }
}

function* createActiveSubModuleClassPracticeSagaV2(
  action: ReturnType<typeof createActiveSubModuleClassPracticeV2>
): Generator<any, void, any> {
  const { sub_module_ids, class_id, module_id, type } = action.payload;

  yield put(setLoadingActiveSubModuleClassPractice(true));
  try {
    const res: ResponseType = yield call(
      resourceService.post,
      API_URL + `/api/active_submodule_class_practice/`,
      { sub_module_id: sub_module_ids, class_id, module_id }
    );

    if (res?.status === 201) {
      yield put(setSuccessActiveSubModuleClassPractice(true));
      yield put(setResultsActiveSubModuleClassPractice(res.data));
      const refresh: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/sub_modules_v2/`,
        { params: { module_id, class_id, type } }
      );
      if (refresh.status === 200) {
        yield put(setSubModuleV2(refresh.data));
      }
    }

    yield put(setLoadingActiveSubModuleClassPractice(false));
  } catch (error: any) {
    console.error(error);
    yield put(setLoadingActiveSubModuleClassPractice(false));
    yield put(setSuccessActiveSubModuleClassPractice(false));
  }
}

function* createActiveSubmoduleClassExamSaga(
  action: ReturnType<typeof createActiveSubmoduleClassExam>
): Generator<any, void, any> {
  const {
    class_id,
    sub_module_id,
    module_id,
    time_active_days,
    time_end_days,
    max_exam,
    time_value,
    exam_pass_score,
    type,
  } = action.payload;

  yield put(setLoadingActiveSubModuleClassPractice(true));
  try {
    const res: ResponseType = yield call(
      resourceService.post,
      API_URL + '/api/active_submodule_class_exam/',
      {
        class_id: Number(class_id),
        sub_module_id,
        time_active_days,
        time_end_days,
        max_exam,
        time_value,
        exam_pass_score,
      }
    );

    if (res?.status === 200 || res?.status === 201) {
      yield put(setSuccessActiveSubModuleClassPractice(true));
      yield put(setResultsActiveSubModuleClassPractice(res.data ?? {}));
      toast.success('Giao bài kiểm tra thành công');

      if (module_id && class_id != null) {
        const refresh: ResponseType = yield call(
          resourceService.get,
          API_URL + '/api/sub_modules_v2/',
          { params: { module_id, class_id, type } }
        );
        if (refresh.status === 200) {
          yield put(setSubModuleV2(refresh.data));
        }
      }
    }
    yield put(setLoadingActiveSubModuleClassPractice(false));
  } catch (error: any) {
    console.error(error);
    const msg = error?.response?.data?.detail ?? error?.response?.data?.error ?? 'Giao bài kiểm tra thất bại';
    toast.error(typeof msg === 'string' ? msg : 'Giao bài kiểm tra thất bại');
    yield put(setResultsActiveSubModuleClassPractice({ errors: [{ error: msg }] }))
    yield put(setLoadingActiveSubModuleClassPractice(false));
    yield put(setSuccessActiveSubModuleClassPractice(false));
  }
}

function* createExamExtendSaga(
  action: ReturnType<typeof createExamExtend>
): Generator<any, void, any> {
  const { class_id, submodule, time_active, time_end, student_ids, extends_exams, module_id, type } = action.payload;

  yield put(setLoadingActiveSubModuleClassPractice(true));
  try {
    const res: ResponseType = yield call(
      resourceService.post,
      API_URL + '/api/exam_extends/',
      {
        class_id: Number(class_id),
        submodule,
        time_active,
        time_end,
        student_ids,
        extends_exams,
      }
    );

    if (res?.status === 200 || res?.status === 201) {
      yield put(setSuccessActiveSubModuleClassPractice(true));
      yield put(setResultsActiveSubModuleClassPractice(res.data ?? {}));
      toast.success('Giao bài kiểm tra cho học sinh thành công');

      if (module_id && class_id != null) {
        const refresh: ResponseType = yield call(
          resourceService.get,
          API_URL + '/api/sub_modules_v2/',
          { params: { module_id, class_id, type } }
        );
        if (refresh.status === 200) {
          yield put(setSubModuleV2(refresh.data));
        }
      }
    }
    yield put(setLoadingActiveSubModuleClassPractice(false));
  } catch (error: any) {
    console.error(error);
    const msg = error?.response?.data?.detail ?? error?.response?.data?.error ?? 'Giao bài kiểm tra thất bại';
    toast.error(typeof msg === 'string' ? msg : 'Giao bài kiểm tra thất bại');
    yield put(setResultsActiveSubModuleClassPractice({ errors: [{ error: msg }] }));
    yield put(setLoadingActiveSubModuleClassPractice(false));
    yield put(setSuccessActiveSubModuleClassPractice(false));
  }
}

function* addGradeModuleSaga(action: any) {
  const { moduleIds, gradeId } = action.payload; // gradeId will be an array
  yield put(setLoadingAddModuleGrade(1));

  const successGrades: number[] = [];
  const failedGrades: number[] = [];

  try {
    for (let i = 0; i < gradeId.length; i++) {
      const id = gradeId[i];
      try {
        const response: ResponseType = yield call(
          resourceService.post,
          `${API_URL}/api/grades/${id}/add_grade_module/`,
          { module_id: moduleIds }
        );

        if (response.status === 201) {
          yield put(setGradeModuleList(response.data));
          successGrades.push(id);
          toast.success(`Đăng ký môn học thành công cho khối với ID ${id} !`);
        } else {
          failedGrades.push(id);
          toast.error(`Đăng ký môn học thất bại cho khối với ID ${id} !`);
        }
      } catch (err: any) {
        failedGrades.push(id);
        const detailError = err?.response?.data?.detail;
        toast.error(`Đăng ký môn học thất bại cho khối với ID ${id} !`);
        console.error("Saga error:", detailError || err);
      }
    }

    yield put(setLoadingAddModuleGrade(2));
  } catch (outerErr) {
    yield put(setLoadingAddModuleGrade(2));
  }
}

function* deleteModuleSaga(
  action: ReturnType<typeof deleteModule>,
): Generator<any, void, any> {
  const { id } = action.payload;
  yield put(setLoadingDeleteModule(true));
  try {
    const response: ResponseType = yield call(
      resourceService.delete,
      API_URL + `/api/modules/${id}/`,
    );
    if (response.status === 204 || response.status === 200) {
      toast.success('Đã xóa môn học thành công.');
      yield put(setDeleteModuleSuccess(true));
    }
  } catch (error: any) {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 400) {
      toast.error(
        typeof detail === 'string' && detail.trim()
          ? detail
          : 'Yêu cầu không hợp lệ.',
      );
    } else if (status === 403) {
      toast.error('Bạn không có quyền thực hiện thao tác này.');
    } else if (status !== 401) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Xóa môn học thất bại';
      toast.error(typeof msg === 'string' ? msg : 'Xóa môn học thất bại');
    }
    console.error(error);
  } finally {
    yield put(setLoadingDeleteModule(false));
  }
}

export default function* moduleSaga(): Generator<any, void, any> {
  yield takeLatest(fetchModuleAvailableList, fetchModuleAvailableListSaga);
  yield takeLatest(createModule, createModuleSaga);
  yield takeLatest(fetchModuleDetail, fetchModuleDetailSaga);
  yield takeLatest(fetchSubModuleTree, fetchSubModuleTreeSaga);
  yield takeLatest(fetchSubModuleV2, fetchSubModuleV2Saga);
  yield takeLatest(createSubModule, createSubModuleSaga);
  yield takeLatest(deleteSubModule, deleteSubModuleSaga);
  yield takeLatest(fetchSubModuleDetail, fetchSubModuleDetailSaga);
  yield takeLatest(fetchEdxQuestionByModule, fetchEdxQuestionByModuleSaga);
  yield takeLatest(updateSubModule, updateSubModuleSaga);
  yield takeLatest(updateModule, updateModuleSaga);
  yield takeLatest(deleteSubModlueQuestion, deleteSubModlueQuestionSaga);
  yield takeLatest(fetchEdxListCourse, fetchEdxListCourseSaga);
  yield takeLatest(syncEdxCourse, syncEdxCourseSaga);
  yield takeLatest(syncEdxCourseDirect, syncEdxCourseDirectSaga);
  yield takeLatest(cloneModuleFromEdxCourse, cloneModuleFromEdxCourseSaga);
  yield takeLatest(fetchActiveSubModuleClassPractice, fetchActiveSubModuleClassPracticeSaga);
  yield takeLatest(createActiveSubModuleClassPractice, createActiveSubModuleClassPracticeSaga);
  yield takeLatest(createActiveSubModuleClassPracticeV2, createActiveSubModuleClassPracticeSagaV2);
  yield takeLatest(createActiveSubmoduleClassExam, createActiveSubmoduleClassExamSaga);
  yield takeLatest(createExamExtend, createExamExtendSaga);
  yield takeLatest(addGradeModule, addGradeModuleSaga);
  yield takeLatest(deleteModule.type, deleteModuleSaga);
}
